import React from 'react'

import Button from '../Button/Button'
import Icon from '../Icon2/Icon'
import { Truncate } from '../Truncate/Truncate'
import SkeletonTile from '../SkeletonTile/SkeletonTile'
import './SearchBar.css'

export const SearchSuggestion = (props) => {
  const { t = (key: string) => '', recentSearchArr, onRecentSearchClick, handleRecentSearchClear, historyInfo, loading } = props

  const SearchHistoryInformation = () => {
    if (historyInfo) {
      return <div className="SearchBar__input__box__info">{historyInfo}</div>
    }
    return null
  }

  return (
    <>
      <div className="SearchBar__input__box" data-test-id={'cs-search-bar-suggestions'}>
        <div className="SearchBar__input__box__header flex-justify">
          <div className="SearchBar__input__box__header--title flex-v-center" data-test-id="cs-search-bar-history">{t('SearchBar.search_history') || 'Search History'}</div>
          <Button
            version="v2"
            buttonType="tertiary"
            size="small"
            onClick={(e) => handleRecentSearchClear(e, { action: 'clearAll' })}
            testId="cs-search-bar-suggestions-clear"
            className="mr-8"
            disabled={!recentSearchArr.length}
          >
            {t('SearchBar.clear_all') || 'Clear All'}
          </Button>
        </div>
        <div className="SearchBar__input__box__list">
          <SearchHistoryInformation />
          {loading ? (
            <div className="SearchBar__input__box__content SearchBar__input__box__no-result flex-v-center flex-justify">
              <div className="flex-v-center" >
                <SkeletonTile
                  numberOfTiles={1}
                  tileHeight={12}
                  tileWidth={250}
                  tileRadius={6}
                  tileBottomSpace={10}
                  tileTopSpace={10}
                  tileleftSpace={18}
                />
              </div>
            </div>
          ) :
            !recentSearchArr.length ? (
              <div className="SearchBar__input__box__content SearchBar__input__box__no-result flex-v-center flex-justify">
                <div className="ml-4 SearchBar__input__box__content--text">{t('SearchBar.no_recent_searches') || 'No recent searches'}</div>
              </div>
            ) : recentSearchArr.map((searchObj, i) => {
              return (
                <div
                  className="SearchBar__input__box__content flex-v-center flex-justify"
                  key={i}
                  onClick={() => onRecentSearchClick(searchObj)}>
                  <div className="flex-v-center" data-test-id={'cs-search-suggestions-item'}>
                    <Icon version="v2" icon="DeploymentHistory" size="small" />
                    <div className="ml-4 SearchBar__input__box__content--text">
                      <Truncate isResponsive truncateFrom="end">
                        {searchObj.primary}
                      </Truncate>
                    </div>
                    <div className="ml-4 SearchBar__input__box__content--suffix">
                      <Truncate isResponsive truncateFrom="end">
                        {searchObj.secondary}
                      </Truncate>
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}
